import firebase from "firebase/app";
import "firebase/auth";
import axios from "axios";

export const getProducts = async () => {
  const token = await firebase.auth().currentUser.getIdToken();

  let url = "Products";

  try {
    const response = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (response.status === 200 && response.data) {
      const data = response.data;
      return data;
    }
  } catch (e) {
    console.log("Error while getting Products");
    return null;
  }

  return [];
};

export const addBoxes = async (products) => {
  let productsWithQuantity = [];
  products.forEach((product) => {
    if (product.checked && product.boxQuantity > 0) {
      productsWithQuantity.push({
        barcode: product.barCode,
        quantity: product.boxQuantity,
      });
    }
  });
  if (productsWithQuantity.length <= 0) return;

  const token = await firebase.auth().currentUser.getIdToken();
  let url = "WafrConsole/AddProductsBox";
  try {
    const response = await axios.post(
      url,
      { products: productsWithQuantity },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (response.status === 200 && response.data) {
      const data = response.data.value;
      console.log(data);
      if (data.success) alert("products boxes added successfully");
      else alert("error : " + data.error);
      return data;
    }
  } catch (e) {
    console.log("Error while adding retailer stock");
    return null;
  }
  return null;
};

export const getProductsBoxes = async () => {
  const token = await firebase.auth().currentUser.getIdToken();

  let url = "WafrConsole/GetProductsBoxes";

  try {
    const response = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (response.status === 200 && response.data) {
      const data = response.data;
      return data.boxes;
    }
  } catch (e) {
    console.log("Error while getting Products");
    return null;
  }

  return [];
};

export const addBoxesQrcodes = async (productsBoxes, title) => {
  let productsWithQuantity = [];
  productsBoxes.forEach((box) => {
    if (box.checked && box.qrCodesQuantity > 0) {
      productsWithQuantity.push({
        productsBoxId: box.id,
        quantity: parseInt(box.qrCodesQuantity),
      });
    }
  });
  if (productsWithQuantity.length <= 0) return;

  const token = await firebase.auth().currentUser.getIdToken();
  let url = "WafrConsole/GenerateProductQrcodes";
  let payload = { productsBoxesInfo: productsWithQuantity, title };
  console.log(JSON.stringify(payload));
  try {
    const response = await axios.post(url, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    });
    alert("success :" + response.data.success)
  } catch (e) {
    console.log("error ", e);
    alert("Error while generating products qrcodes");
    return null;
  }
  return null;
};

export const addProducts = async (products) => {
  const token = await firebase.auth().currentUser.getIdToken();
  let url = "Products/AddProducts";
  try {
    const response = await axios.post(
      url,
      {
        products,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (response.status === 200 && response.data) {
      const data = response.data;
      return data;
    } else {
      alert("Server Error while adding new products");
    }
  } catch (e) {
    console.log("Error while adding new products");
    return null;
  }
  return null;
};


export const getProductsBoxesFiles = async () => {
  const token = await firebase.auth().currentUser.getIdToken();

  let url = "WafrConsole/GetQrcodesFiles";

  try {
    const response = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (response.status === 200 && response.data) {
      const data = response.data;
      return data.files;
    }
  } catch (e) {
    console.log("Error while getting Products");
    return null;
  }

  return [];
};
